import React from 'react'

import { MainWrapper } from 'components/MainWrapper'
import { FlexContainer } from 'components/Flex'
import { useTriage } from 'hooks/useTriage'
import { ProfileTypes } from 'types/enums'

import { Heading } from '../Heading'
import { Filters } from '../Filters'
import { TriageTable } from '../Table/TriageTable'
import { LastRefreshDate } from '../LastRefreshDate'

export const Triage = () => {
  const { data, lastRefreshAt } = useTriage()

  return (
    <MainWrapper>
      <FlexContainer column maxWidth="1008px" style={{ marginBottom: '45px' }}>
        <Heading profileType={ProfileTypes.TeamLeader} />
        <Filters />
        <LastRefreshDate date={lastRefreshAt} />
        <TriageTable data={data} />
      </FlexContainer>
    </MainWrapper>
  )
}
